import moment from 'moment';
import { createSlice } from '@reduxjs/toolkit'
import { calcNights } from '../../utils';

const initValue = {
  title: "",
  choice: "NO, THANKS",
  amount: 0,
  price: 0,
  pricePG: 0,
}

const initialState = {
  config: null,
  seasons: null,
  seasons_txt: null,
  seasons_obj: null,
  season: null,
  checkIn: "",//moment(),
  checkOut: "",// null,
  minCheckIn: "",
  maxCheckIn: "",
  minCheckOut: "",
  maxCheckOut: "",
  guests: 1,
  nights: 0,
  checkInError: false,
  checkOutError: false,
  guestsError: false,
  bookError: false,
  promoCode: null,
  room: null,
  roomType: null,
  mealsBreakfast: initValue,
  mealsLunch: initValue,
  mealsDinner: initValue,
  activity1: initValue,
  activity2: initValue,
  activity3: initValue,
  activity4: initValue,
  activity5: initValue,
  activity6: initValue,
  activity7: initValue,
  activity8: initValue,
  activity9: initValue,
  transportTambor: initValue,
  transportSanJose: initValue,
  transportLiberia: initValue,
  transportCobano: initValue,
  transports: [],
  overnightSanJose: false,
  commentsRooming: "",
  commentsMeals: "",
  commentsActivities: "",
  commentsTransportation: "",
  pack: null,
  prices: null,
  paid: 0,
  extras: [],
  items: [],
  contador: 0,
  refresh: 0,
  msj: {
    contenido: '',
    tipo: '',
  },
  loading: false,
}

const getMinCheckOut = (_checkIn, _min_nights) => {
  return _checkIn ?
    _checkIn.clone().add(_min_nights, "days")
    :
    moment().add(_min_nights, "days")
}

const getMaxCheckOut = (_checkIn, _max_nights) => {
  return _checkIn ?
    _checkIn.clone().add(_max_nights, "days")
    :
    moment().add(_max_nights, "days");
}

const main = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setIni(state, action) {
      state.seasons = action.payload.seasons[0]
      state.seasons_txt = action.payload.seasons[1]
      state.seasons_obj = action.payload.seasons[2]
      state.config = action.payload.config
      state.season = action.payload.seasons[0][moment().format("MMDD")]
      state.minCheckIn = moment()
      state.maxCheckIn = ''
      state.minCheckOut = moment()
      state.maxCheckOut = moment()

      /*
      state.minCheckOut = getMinCheckOut(state.checkIn, action.payload.config.min_nights)
      state.maxCheckOut = getMaxCheckOut(state.checkIn, action.payload.config.max_nights)
      state.checkOut = getMinCheckOut(state.checkIn, action.payload.config.min_nights)
      state.nights = calcNights(state.checkIn, state.checkOut)
      */
      return state
    },
    setCheckIn(state, action) {
      state.checkIn = action.payload.checkIn
      const minCheckOut = getMinCheckOut(action.payload.checkIn, state.config.min_nights)
      const maxCheckOut = getMinCheckOut(action.payload.checkIn, state.config.max_nights)
      const newminout = action.payload.checkIn.clone().add(state.config.min_nights, 'days')
      state.minCheckOut = minCheckOut
      state.maxCheckOut = maxCheckOut
      state.season = state.seasons[action.payload.checkIn.format("MMDD")]
      if (newminout.isAfter(state.checkOut)) {
        state.checkOut = newminout
      }
      if (state.checkOut) {
        state.nights = calcNights(action.payload.checkIn, state.checkOut)
      }
      return state
    },
    setCheckInPack(state, action) {
      state.checkIn = action.payload.date
      state.nights = action.payload.pack.nights
      //const out = action.payload.date.clone().add(parseInt(7), 'days')
      const out = action.payload.date.clone().add(parseInt(action.payload.pack.nights), 'days')
      state.checkOut = out
      state.minCheckOut = out
      state.maxCheckOut = out
      state.maxCheckIn = action.payload.pack.start != "" ? moment(action.payload.pack.start, 'YYYY-MM-DD') : ""
      return state
    },
    setCheckOut(state, action) {
      state.checkOut = action.payload.checkOut
      if (state.checkOut && state.checkIn) {
        state.nights = calcNights(state.checkIn, action.payload.checkOut)
      }
      return state
    },
    setGuests(state, action) {
      state.guests = action.payload
      return state
    },
    setRoom(state, action) {
      // state.room = action.payload.room
      //state.roomType = action.payload.roomType
      state.roomType = action.payload.roomType
      return state
    },
    setMealsBreakfast(state, action) {
      state.mealsBreakfast = action.payload
      return state
    },
    setMealsLunch(state, action) {
      state.mealsLunch = action.payload
      return state
    },
    setMealsDinner(state, action) {
      state.mealsDinner = action.payload
      return state
    },
    setComments(state, action) {
      state["comments" + action.payload.type] = action.payload.value
      return state
    },
    setActivity(state, action) {
      state["activity" + action.payload.pos] = action.payload.data
      return state
    },
    setTransport(state, action) {
      state["transport" + action.payload.type] = action.payload.data
      return state
    },
    setTransportNew(state, action) {
      state.transports[action.payload.pos].value = action.payload.data
      state.transports[action.payload.pos].error = false
      return state
    },
    setOvernightSanJose(state, action) {
      state.overnightSanJose = action.payload
      return state
    },
    setPrices(state, action) {
      state.prices = action.payload
      return state
    },
    setPromoCode(state, action) {
      state.promoCode = action.payload
      //state.prices.discount = action.payload.discount
      return state
    },
    setPack(state, action) {
      let pack = action.payload
      state.pack = pack
      state.nights = parseInt(pack.nights)
      if (pack.start) {
        const desde = moment(pack.start, 'YYYY-MM-DD')
        const hasta = moment(pack.start, 'YYYY-MM-DD').add(parseInt(pack.nights), 'days')
        state.checkIn = desde
        state.checkOut = hasta
        state.maxCheckIn = desde
        state.minCheckIn = desde
        state.maxCheckOut = hasta
        state.minCheckOut = hasta
      }
      return state
    },
    setError(state, action) {
      state[action.payload.type] = action.payload.value
      return state
    },
    setVuelve(state, action) {
      state.checkIn = action.payload.checkIn
      state.checkOut = action.payload.checkOut
      state.guests = action.payload.guests
      state.nights = calcNights(action.payload.checkIn, action.payload.checkOut)
      return state
    },
    resetea(state, action) {
      state = {
        ...state,
        checkIn: "",//moment(),
        checkOut: "",// null,
        minCheckIn: "",
        minCheckOut: "",
        maxCheckOut: "",
        guests: 1,
        nights: 0,
        checkInError: false,
        checkOutError: false,
        guestsError: false,
        bookError: false,
        promoCode: null,
        room: null,
        roomType: null,
        mealsBreakfast: initValue,
        mealsLunch: initValue,
        mealsDinner: initValue,
        activity1: initValue,
        activity2: initValue,
        activity3: initValue,
        activity4: initValue,
        activity5: initValue,
        activity6: initValue,
        activity7: initValue,
        activity8: initValue,
        activity9: initValue,
        transportTambor: initValue,
        transportSanJose: initValue,
        transportLiberia: initValue,
        overnightSanJose: false,
        commentsRooming: "",
        commentsMeals: "",
        commentsActivities: "",
        commentsTransportation: "",
        pack: null,
        prices: null,
        paid: 0
      }
      return state
    },
    vuelveInicio(state, action) {
      state = {
        ...state,
        checkInError: false,
        checkOutError: false,
        guestsError: false,
        bookError: false,
        promoCode: null,
        room: null,
        roomType: null,
        mealsBreakfast: initValue,
        mealsLunch: initValue,
        mealsDinner: initValue,
        activity1: initValue,
        activity2: initValue,
        activity3: initValue,
        activity4: initValue,
        activity5: initValue,
        activity6: initValue,
        activity7: initValue,
        activity8: initValue,
        activity9: initValue,
        transportTambor: initValue,
        transportSanJose: initValue,
        transportLiberia: initValue,
        transportCobano: initValue,
        overnightSanJose: false,
        commentsRooming: "",
        commentsMeals: "",
        commentsActivities: "",
        commentsTransportation: "",
        prices: null,
        paid: 0
      }
      return state
    },
    refresca(state, action) {
      state.refresh = moment().unix()
      return state
    },
    setTransportationStep(state, action) {
      const _transports = action.payload.items.map(trans => {
        return {
          ...trans,
          value: initValue,
          error: false,
          showMoreInfo: false
        }
      })
      state.transports = _transports
      return state
    },
    toggleMoreInfo(state, action) {
      //let _t = [...state.transports]
      state.transports[action.payload].showMoreInfo = !state.transports[action.payload].showMoreInfo
      return state
    },
    setEnquiryFromChoices(state, action) {
      return {
        ...state, ...action.payload.choices,
        checkIn: moment(action.payload.checkIn),
        checkOut: moment(action.payload.checkOut)
      }
    }
  }
})


export const {
  setIni,
  refresca,
  setCheckIn,
  setCheckInPack,
  setCheckOut,
  setGuests,
  setRoom,
  setMealsBreakfast,
  setMealsLunch,
  setMealsDinner,
  setComments,
  setActivity,
  setTransport,
  setOvernightSanJose,
  setPrices,
  setPromoCode,
  setPack,
  setError,
  setVuelve,
  resetea,
  vuelveInicio,
  setTransportationStep,
  toggleMoreInfo,
  setTransportNew,
  setEnquiryFromChoices
} = main.actions

export default main.reducer
